import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import '../styles/Analytics.css';
import 'react-datepicker/dist/react-datepicker.css';

import OldAnalyticsHome from '../containers/OldAnalyticsHome';
import MomentAnalyticsHome from '../containers/moment/MomentAnalyticsHome';
import OnboardingAnalyticsHome from '../containers/onboarding/OnboardingAnalyticsHome';
import UsersAnalyticsHome from '../components/users/UsersAnalyticsHome';
import TeamsAnalyticsHome from '../containers/teams/TeamsAnalyticsHome';
import KpiHome from '../containers/kpi/KpiHome';
import ChannelAnalytics from './ChannelAnalytics';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,

    width: '100%',
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
  },
  tabAnalytics: {
    minWidth: 'unset',
    padding: '0px 5px',
  },
});

class AnalyticsHome extends React.Component {
  renderSwitch(tab) {
    switch (tab) {
      case 0:
        return <KpiHome />;
      case 1:
        return <UsersAnalyticsHome />;
      case 2:
        return <ChannelAnalytics />;
      case 3:
        return <OnboardingAnalyticsHome />;
      case 4:
        return <TeamsAnalyticsHome />;
      case 6:
        return <MomentAnalyticsHome />;
      case 10:
        return <OldAnalyticsHome />;
      default:
        return null;
    }
  }

  render() {
    const { classes, selectedTab, onChangeTab } = this.props;

    return (
      <div className={classes.content}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={classes.headerAnalytics}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                Analytics
              </Typography>
            </div>
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              value={selectedTab}
              onChange={onChangeTab}
              variant="fullWidth"
              scrollButtons="on"
            >
              <Tab classes={{ root: classes.tabAnalytics }} label="KPIs" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Users" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Channels" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Onboarding" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Teams" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Events" disabled />
              <Tab classes={{ root: classes.tabAnalytics }} label="Moments" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Points" disabled />
              <Tab classes={{ root: classes.tabAnalytics }} label="Tags" disabled />
              <Tab classes={{ root: classes.tabAnalytics }} label="Ads" disabled />
              <Tab classes={{ root: classes.tabAnalytics }} label="lim analytics" />
              <Tab classes={{ root: classes.tabAnalytics }} label="Referrals" disabled />
            </Tabs>
            {this.renderSwitch(selectedTab)}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(AnalyticsHome);
